import Input from "../Component/Input";
import InputMenu from "../Component/InputMenu";
import InsideTextBox from "../Component/InsideTextBox";
import MultitextBox from "../Component/MultitextBox";
import MuSelect from "../Component/MultiSelectCreate";
import SelectMenuItem from "../Component/SelectMenuItem";
import MultiSelect from "../Component/MultiSelect";
export const options = [
  { id: 1, label: "Whatsapp", value: 1 },

  { id: 2, label: "Facebook", value: 2 },
  { id: 3, label: "Instagram", value: 3 },
  { id: 4, label: "Google", value: 4 },
  { id: 5, label: "Walk-in", value: 5 },

  { id: 6, label: "Twitter", value: 6 },
  { id: 7, label: "Linkedin", value: 7 },
  { id: 8, label: "Youtube", value: 8 },
  { id: 9, label: "Flyer", value: 9 },
  { id: 10, label: "Referral", value: 10 },
];
export const periodoptions = [
  { id: 1, label: "Select", value: "" },

  { id: 1, label: "Regular", value: "regular" },

  { id: 2, label: "Irregular", value: "irregular" },
];

export const CustomerInfoNonIvf = [
  { tag: Input, img: "age", label: "Date of birth", name: "dob",validation:"date" },
  { tag: Input, img: "age", label: "Sex", name: "sex" },
  { tag: Input, img: "age", label: "Referred by", name: "referredBy" },
  { tag: Input, img: "age", label: "occupation", name: "occupation" },
  

  // { tag: SelectMenuItem, option:options, img: "source", label: "Source", name: "source" },
];
export const CustomerInfo = [
  // { tag: InputMenu, img: "age", label: "Age | Sex  ", name: "age_sex" },
  { tag: Input, img: "age", label: "Date of birth", name: "dob",validation:"date" },
  { tag: Input, img: "age", label: "Age", name: "age" },
  { tag: Input, img: "sex", label: "Sex", name: "sex" },
  
  {
    tag: Input,
    img: "name",
    label: "Spouse Name ",
    name: "spouseName",
    validation: "spouseName",
  },
  {
    tag: Input,
    img: "age",
    label: "Spouse Age",
    name: "spouseAge",
  },{
    tag: Input,
    img: "sex",
    label: "Spouse Sex",
    name: "spouseSex",
  },
  { tag: Input, img: "referred", label: "Referred by", name: "referredBy" },
  { tag: Input, img: "occupation", label: "Occupation", name: "occupation" },
  {
    tag: Input,
    img: "married",
    label: "Years Married",
    name: "yearsMarried",
    validation: "marriage",
  },
  // { tag: SelectMenuItem, option:options, img: "source", label: "Source", name: "source" },
];
export const PeriodInfo = [
  {
    tag: Input,
    img: "drop",
    label: "LMP (Last mens..)",
    name: "lastPeriod",
    validation: "lastPeriod",
  },
  {
    tag: Input,
    img: "name",
    label: "Cycle length ",
    name: "cycleLength",
    validation: "cycleLength",
    
  },
  {
    tag: Input,
    img: "married",
    label: "Avg period length",
    name: "avgPeriodLength",
    validation: "avgPeriodLength",
  },
  {
    tag: Input,
    img: "age",
    label: "Ovulation date",
    name: "ovulationDate",
    validation: "ovulationDate",

  },
  // { tag: SelectMenuItem, option:options, img: "source", label: "Source", name: "source" },
];
export const PeriodInfotwo = [
  {
    tag: Input,
    img: "drop",
    label: "LMP (Last mens..)",
    name: "lastPeriod",
    validation: "lastPeriod",
  },
  {
    tag: Input,
    img: "name",
    label: "Cycle length ",
    name: "cycleLength",
    options: [
      { id: 1, label: "30-60 days", value: "30-60 days" },
      { id: 1, label: "2-6 months", value: "2-6 months" },
      { id: 2, label: "Less than 21 days", value: "Less than 21 days" },
    ],
    validation: "cycleLength",
  },
  {
    tag: Input,
    img: "married",
    label: "Idea about cycle",
    name: "ideaAboutCycle",
    validation: "ideaAboutCycle",
  },
  {
    tag: Input,
    img: "age",
    label: "Period flow",
    name: "periodFlow",
     
    options: [
      { id: 1, label: "Heavier", value: "Heavier" },
      { id: 2, label: "Moderate", value: "Moderate" },


      { id: 3, label: "Scanty", value: "Scanty" },
    ],
  },
  // { tag: SelectMenuItem, option:options, img: "source", label: "Source", name: "source" },
];
export const ContactInfo = [
  {
    tag: Input,
    img: "whatsapp",
    label: "Phone 1 *",
    name: "phone1",
    validation: "phone",
    required: true,
  },
  // {
  //   tag: Input,
  //   img: "phone",
  //   label: "Phone 2",
  //   name: "phone2",
  //   validation: "phone",
  // },
  {
    tag: Input,
    img: "email",
    label: "Email 1",
    name: "email1",
    validation: "email",
  },
  // {
  //   tag: Input,
  //   img: "email",
  //   label: "Email 2",
  //   name: "email2",
  //   validation: "email",
  // },
  { tag: Input, img: "city", label: "City", name: "city" },
  { tag: Input, img: "area", label: "Area", name: "area" },
];
export const MedicalDetails = [
  {
    tag: InsideTextBox,
    label: "IVF",
    name: "ivf",
    yearName: "ivfYear",
    monthName: "ivfMonth",
    validation: "month",
  },
  {
    tag: InsideTextBox,
    label: "IUI",
    name: "iui",
    yearName: "iuiYear",
    monthName: "iuiMonth",
    validation: "month",
  },
  {
    tag: InsideTextBox,
    label: "ICSI",
    name: "icsi",
    yearName: "icsiYear",
    monthName: "icsiMonth",
    validation: "year",
  },
  {
    tag: InsideTextBox,
    label: "Miscarriages",
    name: "miscarriages",
    yearName: "miscarriagesYear",
    monthName: "miscarriagesMonth",
    validation: "carriage",
  },
  {
    tag: MultitextBox,
    img: "",
    label: "Children",
    name: "children",
    first: "childrenONE",
    second: "childrenTWO",
    third: "childrenTHREE",
    validation: "children",
  },
  { tag: Input, img: "drop", label: "LMP (Last mens..)", name: "lmp", validation: 'lmp' },
  { tag: MuSelect, img: "name", label: "Health issues", name: "healthIssues" },
  {
    tag: MuSelect,
    img: "name",
    label: "Spouse Health issue",
    name: "spouseHealthIssues",
  },
];
export const MedicalDetailsNonIvf = [
  { tag: Input, img: "", label: "Blood Group", name: "bloodGroup" },
  { tag: Input, img: "", label: "Height", name: "height" },
  { tag: Input, img: "", label: "Weight", name: "weight" },
  { tag: Input, img: "", label: "Blood Pressure", name: "bp" },
  { tag: Input, img: "", label: "Spo", name: "spo2",sub:"2" },
  { tag: Input, img: "", label: "Drug Allergy", name: "drugAllergy" },

];
export const MedicalDetailsIvf = [
  { tag: Input, img: "", label: "Blood Group", name: "bloodGroup" },
  { tag: Input, img: "", label: "Height", name: "height" },
  { tag: Input, img: "", label: "Weight", name: "weight" },
  { tag: Input, img: "", label: "Blood Pressure", name: "bp" },
  { tag: Input, img: "", label: "Spo", name: "spo2",sub:"2" },
  { tag: Input, img: "", label: "Drug Allergy", name: "drugAllergy" },
  {
    tag: InsideTextBox,
    label: "IVF",
    name: "ivf",
    yearName: "ivfYear",
    monthName: "ivfMonth",
    validation: "month",
  },
  {
    tag: InsideTextBox,
    label: "IUI",
    name: "iui",
    yearName: "iuiYear",
    monthName: "iuiMonth",
    validation: "month",
  },
  {
    tag: InsideTextBox,
    label: "ICSI",
    name: "icsi",
    yearName: "icsiYear",
    monthName: "icsiMonth",
    validation: "year",
  },
  {
    tag: InsideTextBox,
    label: "Miscarriages",
    name: "miscarriages",
    yearName: "miscarriagesYear",
    monthName: "miscarriagesMonth",
    validation: "carriage",
  },
  {
    tag: MultitextBox,
    img: "",
    label: "Children",
    name: "children",
    first: "childrenONE",
    second: "childrenTWO",
    third: "childrenTHREE",
    validation: "children",
  },
  { tag: Input, img: "drop", label: "LMP (Last mens..)", name: "lmp", validation: 'lmp' },
  { tag: MuSelect, img: "name", label: "Health issues", name: "healthIssues" },
  {
    tag: MuSelect,
    img: "name",
    label: "Spouse Health issue",
    name: "spouseHealthIssues",
  },
];

export const CycleIq = [
  { tag: Input, img: "", label: "BMI", name: "bmi" },
  { tag: Input, img: "", label: "AMH(ng/nl)", name: "amh_ng_ml" },
  { tag: Input, img: "", label: "AFC", name: "afc" },
  { 
    tag: MuSelect, 
    label: "Comorbidities", 
    name: "comorbidities",
  },
  { tag: Input, img: "", label: "Other Medications", name: "otherMedications" },
];

export const Extras = [
  { tag: Input, img: "name", label: "Occupation", name: "occupation" },
  {
    tag: Input,
    img: "name",
    label: "Spouse Occupation",
    name: "spouseOccupation",
  },
  { tag: Input, img: "", label: "Area of Interest", name: "areaOfInterest" },
];
export const ServiceChosen = [
  {
    imgPath: require("../../../../assets/DigitalMarketing/image/customer/status/whatsapp.png"),
    label: "Mimo",
    selPath: require("../../../../assets/DigitalMarketing/image/customer/status/whatsapp_sel.png"),
  },
  {
    imgPath: require("../../../../assets/DigitalMarketing/image/customer/status/apple.png"),
    label: "Bootcamp",
    selPath: require("../../../../assets/DigitalMarketing/image/customer/status/apple_sel.png"),
  },
  {
    imgPath: require("../../../../assets/DigitalMarketing/image/customer/status/clinic.png"),
    label: "Fertility Clinic",
    selPath: require("../../../../assets/DigitalMarketing/image/customer/status/clinic_sel.png"),
  },
  {
    imgPath: require("../../../../assets/DigitalMarketing/image/customer/status/preganancy.png"),
    label: "Pregnancy",
    selPath: require("../../../../assets/DigitalMarketing/image/customer/status/preganancy_sel.png"),
  },
];
